/* global React, Icon */
const { useState: useStateNav, useEffect: useEffectNav } = React;

function Nav() {
  const [scrolled, setScrolled] = useStateNav(false);
  const [open, setOpen] = useStateNav(false);
  useEffectNav(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffectNav(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  const t = (k) => window.i18n.t(k);
  const loc = window.i18n.getLocale();
  const setLoc = (l) => {
    window.i18n.setLocale(l);
  };

  const links = () => [
    [t("nav.link.problem"), "#problem"],
    [t("nav.link.directions"), "#directions"],
    [t("nav.link.case"), "#case"],
    [t("nav.link.calculator"), "#calculator"],
    [t("nav.link.pricing"), "#pricing"],
    [t("nav.link.faq"), "#faq"],
  ];

  // 5-locale switcher (Phase 6.1). Native names + flags; the option list is
  // driven by window.i18n.SUPPORTED so a future locale (e.g. KZ) extends the
  // switcher automatically once registered upstream.
  const LANG_LABELS = {
    uk: { flag: "🇺🇦", short: "UA", native: "Українська" },
    ru: { flag: "🇷🇺", short: "RU", native: "Русский" },
    en: { flag: "🇬🇧", short: "EN", native: "English" },
    pl: { flag: "🇵🇱", short: "PL", native: "Polski" },
    ro: { flag: "🇷🇴", short: "RO", native: "Română" },
  };
  const supportedLocales = (window.i18n &&
    Array.isArray(window.i18n.SUPPORTED) &&
    window.i18n.SUPPORTED) || ["uk", "ru", "en", "pl", "ro"];

  const LangSwitch = ({ className }) => (
    <div
      className={"lang-switch" + (className ? " " + className : "")}
      role="group"
      aria-label={t("nav.aria.lang")}
    >
      {supportedLocales.map((code) => {
        const label = LANG_LABELS[code] || { flag: "", short: code.toUpperCase(), native: code };
        const isActive = loc === code;
        return (
          <button
            key={code}
            type="button"
            className={`lang-btn ${isActive ? "active" : ""}`}
            onClick={() => setLoc(code)}
            aria-pressed={isActive}
            aria-current={isActive ? "true" : undefined}
            title={label.native}
            lang={code}
          >
            {label.flag} {label.short}
          </button>
        );
      })}
    </div>
  );

  return (
    <>
      <div className={`nav-wrap ${scrolled ? "scrolled" : ""}`}>
        <div className="nav">
          <a href="#" className="nav-logo">
            <span className="nav-logo-mark">H</span>
            <span>
              healbot<span style={{ color: "var(--muted-2)", fontWeight: 500 }}>.pro</span>
            </span>
          </a>
          <nav className="nav-links" aria-label={t("nav.aria.main")}>
            {links().map(([l, h]) => (
              <a key={h} href={h}>
                {l}
              </a>
            ))}
          </nav>
          <div className="nav-cta">
            <LangSwitch />
            <a href="#" className="btn btn-ghost btn-sm" style={{ gap: 8 }}>
              <Icon name="tg" size={16} />
              {t("nav.cta.telegram")}
            </a>
            <a href="#cta" className="btn btn-primary btn-sm">
              {t("nav.cta.demo")}
            </a>
            <div className="nav-mobile">
              <a
                href="#"
                aria-label={t("nav.aria.telegram")}
                className="hamburger"
                style={{ background: "#27A7E7", color: "#fff", border: "none" }}
              >
                <Icon name="tg" size={20} />
              </a>
              <button
                className="hamburger"
                aria-label={t("nav.aria.openmenu")}
                onClick={() => setOpen(true)}
              >
                <Icon name="menu" size={22} />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/*
        a11y: when drawer is closed we use the `inert` attribute so the entire subtree is
        non-focusable and ignored by ATs. Previously we used `aria-hidden={!open}` which
        Lighthouse flagged because focusable children remain in the tab order even when
        the parent is aria-hidden. `inert` solves both at once. React renders falsy
        attributes as omitted so `inert={open ? undefined : ""}` toggles cleanly.
      */}
      <div
        className={`nav-drawer ${open ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={t("nav.aria.openmenu")}
        inert={open ? undefined : ""}
      >
        <div className="nav-drawer-head">
          <a href="#" className="nav-logo" onClick={() => setOpen(false)}>
            <span className="nav-logo-mark">H</span>
            <span>
              healbot<span style={{ color: "var(--muted-2)", fontWeight: 500 }}>.pro</span>
            </span>
          </a>
          <button
            className="hamburger"
            onClick={() => setOpen(false)}
            aria-label={t("nav.aria.closemenu")}
          >
            <Icon name="x" size={22} />
          </button>
        </div>
        <div className="nav-drawer-body">
          {links().map(([l, h]) => (
            <a key={h} href={h} onClick={() => setOpen(false)}>
              {l}
            </a>
          ))}
        </div>
        <div className="nav-drawer-foot">
          <a href="#" className="btn btn-tg btn-lg">
            <Icon name="tg" size={18} /> {t("nav.drawer.telegram")}
          </a>
          <a href="#cta" className="btn btn-primary btn-lg" onClick={() => setOpen(false)}>
            {t("nav.cta.demo")}
          </a>
          <LangSwitch />
        </div>
      </div>
    </>
  );
}

window.Nav = Nav;
